import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isTemplate: false,
};

export const isTemplateSlice = createSlice({
  name: "isTemplate",
  initialState,
  reducers: {
    changeIsTemplate: (state, action) => {
      state.isTemplate = action.payload;
    },
  },
});

export const { changeIsTemplate } = isTemplateSlice.actions;

export default isTemplateSlice.reducer;
